const clearPersistedState = () => {
  localStorage.removeItem('persist:auth');
  localStorage.removeItem('persist:userContext');
};

export { clearPersistedState };
